export default "__VITE_ASSET__DAyL$UfR__"